import { BIG_ZERO } from 'config/constants/number'
import { TokenAmount } from 'config/types'
import {
  DepositBonus,
  DepositCashbackBonus,
  DepositCashBonus,
  DepositFreespinBonus,
  FreespinDepositBonus,
  UserBonus,
} from 'config/types/bonus/userBonus'
import { DepositRewardEnum } from './constants'

interface IDepositBonusRewardBase {
  type: DepositRewardEnum
}

interface IDepositBonusRewardPercent extends IDepositBonusRewardBase {
  type: DepositRewardEnum.Percent
  value: number
}

interface IDepositBonusRewardCash extends IDepositBonusRewardBase {
  type: DepositRewardEnum.Cash
  value: TokenAmount
}

interface IDepositBonusRewardFreeSpin extends IDepositBonusRewardBase {
  type: DepositRewardEnum.FreeSpin
  value: number
}

interface IDepositCashbackReward extends IDepositBonusRewardBase {
  type: DepositRewardEnum.Cashback
  value: number
}

type IDepositBonusReward =
  | IDepositBonusRewardPercent
  | IDepositBonusRewardCash
  | IDepositBonusRewardFreeSpin
  | IDepositCashbackReward

export const getDepositBonusReward = (bonus: UserBonus, depositAmount?: TokenAmount): IDepositBonusReward => {
  if (bonus instanceof DepositBonus) {
    if (depositAmount?.amount.gt(BIG_ZERO)) {
      const { amount, token } = depositAmount
      return {
        value: {
          token,
          amount: amount.multipliedBy(Number(bonus.percent || 0) / 100),
        } as TokenAmount,
        type: DepositRewardEnum.Cash,
      }
    }
    return {
      value: bonus.percent,
      type: DepositRewardEnum.Percent,
    }
  }

  if (
    bonus instanceof DepositCashBonus ||
    (bonus instanceof FreespinDepositBonus && bonus.bonusAmount.amount.gt(BIG_ZERO))
  ) {
    return {
      value: { token: bonus.bonusAmount.token, amount: bonus.bonusAmount.amount } as TokenAmount,
      type: DepositRewardEnum.Cash,
    }
  }

  if (bonus instanceof DepositFreespinBonus && !(bonus instanceof FreespinDepositBonus)) {
    return {
      value: bonus.freeSpinAmount,
      type: DepositRewardEnum.FreeSpin,
    }
  }

  if (bonus instanceof DepositCashbackBonus) {
    return {
      value: bonus.cashbackRate,
      type: DepositRewardEnum.Cashback,
    }
  }
  return {
    value: null,
    type: null,
  }
}
